import { z } from "zod";

export const feedbackSchema = z.object({
    feedback: z
        .string()
        .min(1, "errors.feedbackRequired")
        .min(10, "errors.feedbackMinLength"),
});
